import clsx from "clsx";
import React, { FC, useState } from "react";


interface ICheckboxProps {
  label?: string | JSX.Element;
  id?: string;
  name?: string;
  disabled?: boolean;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>)=> void | null | any;
  onBlur?: (e: React.FocusEvent<any, Element>)=> void | null | any;
  error?: string | undefined;
  required?: boolean;
  helperText?: string;
  classes?: string;
}

function Checkbox({ 
  label, 
  id, 
  name, 
  disabled=false,
  checked = false,
  onChange,
  onBlur,
  error,
  required = false,
  helperText,
  classes
}: ICheckboxProps): JSX.Element {

  return (
    <div className={clsx("space-x-6", {["animate-wiggle"]: error && required})}>
      <label className={clsx(
        "inline-flex items-center",
        disabled? "cursor-not-allowed" : "cursor-pointer"
      )}>
        <input
          type="checkbox"
          className={clsx(
            "border border-primary-main",
            "checked:outline-primary-main focus:outline-white dark:focus:outline-darkBg outline-none active:outline-white dark:active:outline-darkBg text-primary-main dark:text-darkBg-mainText rounded",
            disabled? "bg-gray-300 cursor-not-allowed" : "bg-white dark:bg-darkBg",
          )}
          style={{accentColor: "#FBC02D"}}
          name={name}
          id={id}
          checked={checked}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
        />
        <span className={clsx(
          "ml-2 text-sm font-medium",
          disabled? "text-gray-500" : "text-gray-900 dark:text-darkBg-mainText",
          {["text-danger-main"]: error && required}
        )}>{label}</span>
      </label>
    </div>
  );
}

export default Checkbox;

